import axios from 'axios';

const SERVER = (process.env.REACT_APP_SERVER || '').replace(/\/$/, '');

const termLinks = { service: '/terms-of-service', privacy: '/privacy-policy' };

// 서버 약관 목록을 받지 못했을 때 사용하는 기본 약관 목록.
export const defaultTerms = [
    { key: 'service', title: '서비스 이용약관 동의', required: true, url: termLinks.service },
    { key: 'privacy', title: '개인정보 수집·이용 동의', required: true, url: termLinks.privacy },
    { key: 'age14', title: '만 14세 이상입니다', required: true, url: '' },
    { key: 'marketing', title: '마케팅 정보 수신 동의', required: false, url: '' },
];

// 서버 약관 항목 하나를 화면에서 쓰는 { key, title, required, url } 형태로 바꾼다.
function normalizeTerm(item) {
    const key = item?.key || item?.id || item?.code || item?.type;
    if (typeof key !== 'string' || !key) return null;
    const fallback = defaultTerms.find(term => term.key === key);
    return {
        key,
        title: item.title || item.name || item.label || fallback?.title || key,
        required: typeof item.required === 'boolean' ? item.required : Boolean(fallback?.required),
        url: item.url || item.link || termLinks[key] || '',
    };
}

// GET /api/auth/terms 응답(배열 또는 { terms })을 약관 목록으로 바꾼다. 비어 있으면 기본 목록을 쓴다.
export function normalizeTerms(data) {
    const list = Array.isArray(data) ? data : Array.isArray(data?.terms) ? data.terms : [];
    const terms = list.map(normalizeTerm).filter(Boolean);
    return terms.length ? terms : defaultTerms;
}

// 서버에서 현행 약관 목록을 가져온다. 실패하면 기본 목록을 돌려준다.
export async function fetchTerms() {
    try {
        const { data } = await axios.get(`${SERVER}/api/auth/terms`, { timeout: 45000 });
        return normalizeTerms(data);
    } catch {
        return defaultTerms;
    }
}

// 약관 목록과 체크 상태로 서버에 보낼 agreements 객체를 만든다.
export function toAgreements(terms, checked) {
    return Object.fromEntries(terms.map(term => [term.key, Boolean(checked[term.key])]));
}

// 필수 약관에 모두 동의했는지 확인한다.
export function requiredAgreed(terms, checked) {
    return terms.filter(term => term.required).every(term => checked[term.key]);
}
